import { AssetLibraryPage } from '../AssetLibrary';
import DashboardAdmin from './components/DashboardAdmin';
import DashboardApiKeys from './components/DashboardApiKeys';
import DashboardDownloadHistory from './components/DashboardDownloadHistory';
import DashboardHome from './components/DashboardHome';
import type { DashboardSection } from './types';

export interface GetDashboardSectionsOptions {
  showAdmin: boolean;
}

export function getDashboardSections({
  showAdmin,
}: GetDashboardSectionsOptions): DashboardSection[] {
  const sections: DashboardSection[] = [
    {
      slug: 'dashboard',
      label: 'Dashboard',
      content: <DashboardHome />,
    },
    {
      slug: 'library',
      label: 'Library',
      content: <AssetLibraryPage />,
    },
    {
      slug: 'api-keys',
      label: 'API keys',
      content: <DashboardApiKeys />,
    },
    {
      slug: 'download-history',
      label: 'Download History',
      content: <DashboardDownloadHistory />,
    },
  ];

  if (showAdmin) {
    sections.push({
      slug: 'admin',
      label: 'Admin',
      content: <DashboardAdmin />,
    });
  }

  return sections;
}

export function findDashboardSection(
  sections: DashboardSection[],
  slug?: string,
): DashboardSection | undefined {
  return sections.find((section) => section.slug === slug);
}
